import { ReactPortal } from 'react';
import { createPortal } from 'react-dom';
import { MandatoryChildren } from '../../../models/children-props';

export type PortalViewProps<T = unknown> = MandatoryChildren<T>;

export const PortalView = ({ children }: PortalViewProps): ReactPortal | null =>
  typeof document === 'object' ? createPortal(children, document.body) : null;
